<div
  *ngIf="summary$ | ngrxPush as summary"
  fxLayout="column"
  fxLayoutAlign="start center"
  fxLayoutGap="2px"
>
  <div class="mat-caption">
    {{ summary.from | moment | amDateFormat: timeFormat }} -
    {{ summary.to | moment | amDateFormat: timeFormat }}
  </div>
  <div class="mat-caption">{{ summary.duration }}</div>
</div>
